// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"83ff9505","118":"f93b1758","311":"8686b48f","339":"8686b48f","510":"e2dcbc14","799":"9c50a129"}[chunkId] + ".chunk.css";
};